<template>
  <div
    class="page page-layout page-layout-wrapper"
    :class="{ sideBarClose: !sideBarOpened }"
  >
    <template>
      <div class="page-top-header-wrapper">
        <page-header />
      </div>
      <div class="main-container">
        <div class="side-bar-wrapper">
          <side-bar />
        </div>
        <!-- <transition name="fade-transform" mode="out-in"> -->
        <!-- <keep-alive :include="getKeepAliveList">
          <router-view
            class="page-router-wrapper"
            v-if="$route.meta.keepAlive"
            :key="$route.fullPath"
            :class="[
              { height100: $route.meta.height100 },
              { 'no-padding': $route.meta.noPadding }
            ]"
          />
        </keep-alive> -->
        <div :class="`page-content-wrap ${$route.meta.noPadding ? 'no-padding' : ''}`">
          <div id="page-content" class="page-content">
            <router-view
              class="page-router-wrapper"
              :class="[
                // { height100: $route.meta.height100 },
                { 'no-padding': $route.meta.noPadding },
              ]"
            />
          </div>
        </div>
        <!-- </transition> -->
      </div>
    </template>
  </div>
</template>

<script>
import sideBar from '@/components/side-bar/Index';
import pageHeader from '@/components/page-header';

import { mapState } from 'vuex';
export default {
  name: '_Layout',
  components: {
    sideBar,
    pageHeader,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState({
      sideBarOpened: (state) => state.sideBarOpened,
    }),
    // getKeepAliveList() {
    //   return this.$store.state.navigation.cachedViews;
    // },
    showPage() {
      return this.$store.state.user.isLogined && this.$route.meta.noNeedLogin;
    },
    // 当登陆中时当前页面显示loading
    loginLoading() {
      return this.$store.state.user.isLogined;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-layout-wrapper {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  .page-top-header-wrapper {
    width: 100%;
    height: 48px;
  }
  .main-container {
    height: calc(100% - 48px);
    width: 100%;
    background: #f5f5f5;
    transition: all $transition-time;
    display: flex;
    overflow: hidden;
    box-sizing: border-box;
    .side-bar-wrapper {
      flex-shrink: 0;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
    }

    .page-content-wrap {
      flex: 1;
      overflow-x: hidden;
      margin: $primary-padding !important;
      padding: 0 !important;
      &:not(.no-padding) {
        padding: $primary-padding 0 !important;
      }
      background: white;
    }

    .page-content {
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      background: white;
      padding: 0 !important;
    }

    .page-router-wrapper {
      background: white;
      box-sizing: border-box;
      border-radius: 4px;
      margin: 10px;
      padding: 0 !important;
      &:not(.no-padding) {
        padding: 0 $primary-padding !important;
      }
      margin: 0 !important;
      &.height100 {
        height: calc(100vh - 110px);
      }
    }
  }
}
</style>
